import Hosts from '../../../Hosts';

const object_type = 'trainer_user'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`

const base_endpoint = '/trainer'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: Hosts.companycode,
        username: '',
        password: '',
        name: '',
        name_full: '',
        surname: '',
        date_birth: '',
        phone: '',
        //location: '',
        email: '',
        professional_area: '',
        formation_area: '',
        qualifications : {
            id: '',
            level: '',
            name: '',
        },
        employment: {
            employment_status: '',
            employer_entity: '',
            business_sector : '',
            employment_role: ''
        },
        photo: '',
        id_type: 'id_type_citizen_card',
        id_number: '',
        id_validity: '',
        nib_iban: '',
        nif: '',
        terms_checked: '',
        files: [],

    },
    addresses: [{
        //village: '',
        //city: '',
        //type: [],
        //region: '',
        country: '',
        //apartado: '',
        location: '',
        place_birth: '',
        village: '',
        municipality: '',
        //contats: [],
        //principal: '',
        //observation: '',
        postal_code: '',
        address: '',
        //address_detail: '',
    }],
    contacts: [{
        contactemail: '',
        email: '',

        principal: 'true',
        //extensions: [],
        observation: '',

        //building_number: '',
        /*person_responsables: [{
            id: '',
            name: '',
            email: '',
            extensions: '',
            observation: '',
            mobile_phone: ''
        }],*/
    }],
    profile: { name: "trainer_user" },
    notifications: []
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}